import emailjs from '@emailjs/browser';
import { Button, Checkbox, Divider, Stack, Typography, styled, useTheme } from '@mui/material';
import { useState } from 'react';
import { toast } from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getFormattedDateDDMMYY } from '../../../utils/dates';
import { getFullDate } from '../../../utils/utils';
import { ButtonsPrimary, ButtonsTertiary } from '../../ComponentApp/buttoms';
import ReceivedRescuePortfolio from './ReceivedRescuePortfolio';
import {
  RescueBodyContainer,
  TitleAndAmountContainer,
  TitleContainerRescue,
  TitleTextRescue,
} from './RescueComponent';
import ValueSection from './ValueSection';

export const RescueSolutionSection = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.white.main,
  boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
  borderTop: '1px solid rgba(170, 167, 167, 0.25)',
  borderRadius: '16px',
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'row',
  width: '100%',
  justifyContent: 'center',
  alignItems: 'center',
  boxSizing: 'border-box',
}));
export const RsContent = styled(Stack)({
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'center',
  padding: '0px',
  boxSizing: 'border-box',
  flex: '1',
  margin: '0px',
  width: '100%',
});
export const RescueDescription = styled(Stack)(({ theme }) => ({
  borderRadius: '8px',
  background: theme.palette.primary.hoverGradient,
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  boxSizing: 'border-box',
  alignSelf: 'stretch',
  margin: '0px',
  gap: '1rem',
  width: '100%',
}));
export const InstallmentNumbers = styled(Stack)({
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '0px',
  boxSizing: 'border-box',
  alignSelf: 'stretch',
  margin: '0px',
  width: '100%',
});

export const RescuePeriod = styled(Stack)({
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  padding: '0px',
  boxSizing: 'border-box',
  alignSelf: 'stretch',
  width: '100%',
});

export const TitleItemCards = styled(Typography)(({ theme }) => ({
  textAlign: 'left',
  whiteSpace: 'pre-wrap',
  fontSynthesis: 'none',
  color: theme.palette.white.main,
  fontSize: theme.typography.mediumText.fontSize,
  letterSpacing: '0px',
  textDecoration: 'none',
  textTransform: 'none',
  margin: '0px',
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.returnText.fontSize,
  },
}));
export const ResItemCards = styled(Typography)(({ theme }) => ({
  textAlign: 'end',
  whiteSpace: 'pre-wrap',
  fontSynthesis: 'none',
  color: theme.palette.primary.dark,
  fontSize: theme.typography.mediumText.fontSize,
  letterSpacing: '0px',
  textDecoration: 'none',
  textTransform: 'none',
  margin: '0px',
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.returnText.fontSize,
  },
}));

export const WarningMessage = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.warning.main,
  boxShadow: '0px 0px 18px rgba(61, 64, 75, 0.06)',
  boxSizing: 'border-box',
  borderRadius: '8px',
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  padding: '24px 32px',
  alignSelf: 'stretch',
  margin: '26px 0px 0px 0px',
  gap: '0.51rem',
  width: '100%',
}));
export const WarninTitle = styled(Stack)({
  display: 'flex',
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'center',
  padding: '0px',
  boxSizing: 'border-box',
  alignSelf: 'stretch',
  margin: '0px',
  width: '100%',
});
export const WarningAmber = styled('img')({
  width: '24px',
  height: '24px',
  margin: '0px',
});

export const ImportanText = styled(Typography)(({ theme }) => ({
  textAlign: 'left',
  whiteSpace: 'pre-wrap',
  fontSynthesis: 'none',
  color: theme.palette.red.main,
  fontWeight: theme.typography.button.fontWeight,
  fontSize: theme.typography.button.fontSize,
  letterSpacing: '0px',
  textDecoration: 'none',
  textTransform: 'none',
  width: '115.5px',
  margin: '0px 0px 0px 16px',
}));

export const DescriptionText = styled(Typography)(({ theme }) => ({
  textAlign: 'left',
  whiteSpace: 'pre-wrap',
  fontSynthesis: 'none',
  color: theme.palette.primary.dark,
  fontWeight: theme.typography.littleText.fontWeight,
  fontSize: theme.typography.customButton.fontSize,
  letterSpacing: '0px',
  textDecoration: 'none',
  textTransform: 'none',
  alignSelf: 'stretch',
}));
export const DividerCustom = styled(Divider)(({ theme }) => ({
  border: `1px dashed ${theme.palette.textLight.main}`,
  alignSelf: 'stretch',
  margin: '26px 0px 0px 0px',
  width: '100%',
}));

export const TermsAndConditions = styled(Stack)({
  display: 'flex',
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  padding: '0px',
  boxSizing: 'border-box',
  alignSelf: 'stretch',
  margin: '26px 0px 0px 0px',
  width: '100%',
});

export const ContentCheckBox = styled(Stack)({
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  padding: '0px',
  boxSizing: 'border-box',
  alignSelf: 'stretch',
  margin: '0px',
  width: '100%',
});

export const CheckBoxOutlineBlank = styled(Checkbox)({
  width: '24px',
  height: '24px',
  margin: '0px',
});
export const TextDeclaration = styled(Typography)(({ theme }) => ({
  whiteSpace: 'pre-wrap',
  color: theme.palette.textLight.main,
  fontWeight: theme.typography.museoRegular.fontWeight,
  fontSize: theme.typography.button.fontSize,
  letterSpacing: '0px',
  textDecoration: 'none',
  textTransform: 'none',
}));
export const DeclarationSpan = styled(Typography)(({ theme }) => ({
  whiteSpace: 'pre-wrap',
  color: theme.palette.secondary.main,
  fontWeight: theme.typography.h1.fontWeight,
  fontSize: theme.typography.button.fontSize,
  letterSpacing: '0px',
  textDecoration: 'none',
  textTransform: 'none',
}));

export const ButtonGroup = styled(Stack)({
  position: 'relative',
  isolation: 'isolate',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '0px',
  boxSizing: 'border-box',
  margin: '26px 0px 0px 0px',
  width: { md: '60%', xs: '80%' },
  gap: '1rem',
  alignSelf: 'stretch',
});

export const ButtonBack = styled(Button)({
  height: '39px',
  width: '128px',
});

export const TextBtnBack = styled(Typography)(({ theme }) => ({
  textAlign: 'center',
  whiteSpace: 'pre-wrap',
  fontSynthesis: 'none',
  color: theme.palette.primary.main,
  fontWeight: theme.typography.smallText.fontWeight,
  fontSize: theme.typography.button.fontSize,
  letterSpacing: '0px',
  textDecoration: 'none',
  textTransform: 'none',
  margin: '0px',
}));

const CardsResultRescue = ({
  handleSubmitRescue,
  amountRescue,
  selectedRescueType,
  portfolioFileAsComplete,
  marketValue,
  typeProduct,
}) => {
  const [isChecked, setIsChecked] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [receivedRequest, setreceivedRequest] = useState(true);
  const theme = useTheme();

  const navigate = useNavigate();
  const { user } = useSelector(state => state.auth);

  const dateDDMMYY = getFormattedDateDDMMYY();
  const days = 'Según reglamento fondos';
  const date = getFullDate();

  const handleChangeCheckBox = e => {
    setIsChecked(e.target.checked);
  };

  const openTC = () => {
    const { REACT_APP_CONTRACT_PORTFOLIO } = process.env;
    const win = window.open(REACT_APP_CONTRACT_PORTFOLIO, '_blank');
    win.focus();
  };

  const completeName = `${user.name} ${user['custom:paternal-surname']}`;

  const stage = process.env.REACT_APP_CURRENT_STAGE;
  const emailEnv = stage === 'master' ? 'template_4t7di9e' : 'template_9tg538u';

  const handleConfirmRescue = () => {
    setSubmitSuccess(true);
    emailjs
      .send(
        'service_7utjird',
        emailEnv,
        {
          portfolioName: portfolioFileAsComplete?.fileAsComplete,
          rescueAmount: `$ ${amountRescue}`,
          rescueType: selectedRescueType,
          RutCliente: user['custom:dni'],
          dateRescue: dateDDMMYY,
          from_name: completeName,
          reply_to: user?.email,
          name: completeName,
          date: dateDDMMYY,
          portfolio: portfolioFileAsComplete?.fileAsComplete,
          amount: `$ ${amountRescue}`,
          typeRescue: selectedRescueType,
          emailUser: user?.email,
        },
        'EFAYuCkTVHLBFWEFQ',
      )
      .then(
        result => {
          setreceivedRequest(prevState => !prevState);
        },
        error => {
          toast.error('Ups ha ocurrido un error');
        },
      );
  };

  return (
    <>
      {receivedRequest ? (
        <RescueBodyContainer>
          <TitleAndAmountContainer>
            <TitleContainerRescue>
              <TitleTextRescue>Rescatar inversión</TitleTextRescue>
            </TitleContainerRescue>
            <ValueSection marketValue={marketValue} typeProduct={typeProduct} />
          </TitleAndAmountContainer>

          <Stack
            sx={{
              borderRadius: '8px',
              margin: '0px auto',
              width: '100%',
              maxWidth: '1380px',
              marginTop: '30px',
            }}>
            <RescueSolutionSection sx={{ padding: 'clamp(1rem, -0.875rem + 8vw, 2.125rem)' }}>
              <RsContent>
                <RescueDescription
                  sx={{
                    padding: '24px clamp(1rem, -0.6667rem + 7.1111vw, 2rem)',
                  }}>
                  <InstallmentNumbers>
                    <TitleItemCards
                      sx={{
                        color: theme.palette.primary.dark,
                        fontSize: theme.typography.mediumText.fontSize,
                        fontWeight: theme.typography.littleText.fontWeight,
                      }}>
                      Monto solicitado:
                    </TitleItemCards>
                    <ResItemCards
                      sx={{
                        fontSize: theme.typography.mediumText.fontSize,
                        fontWeight: theme.typography.button.fontWeight,
                      }}>
                      $ {amountRescue}
                    </ResItemCards>
                  </InstallmentNumbers>
                  <RescuePeriod>
                    <TitleItemCards
                      sx={{
                        color: theme.palette.primary.dark,
                        fontSize: theme.typography.mediumText.fontSize,
                        fontWeight: theme.typography.littleText.fontWeight,
                      }}>
                      Fecha de solicitud:
                    </TitleItemCards>
                    <ResItemCards
                      sx={{
                        fontSize: theme.typography.mediumText.fontSize,
                        fontWeight: theme.typography.button.fontWeight,
                      }}>
                      {dateDDMMYY}
                    </ResItemCards>
                  </RescuePeriod>
                  <RescuePeriod>
                    <TitleItemCards
                      sx={{
                        color: theme.palette.primary.dark,
                        fontSize: theme.typography.mediumText.fontSize,
                        fontWeight: theme.typography.littleText.fontWeight,
                      }}>
                      Plazo de rescate:
                    </TitleItemCards>
                    <ResItemCards
                      sx={{
                        fontSize: theme.typography.mediumText.fontSize,
                        fontWeight: theme.typography.button.fontWeight,
                      }}>
                      Según reglamento fondos
                    </ResItemCards>
                  </RescuePeriod>
                </RescueDescription>
                <WarningMessage>
                  <WarninTitle>
                    <WarningAmber src='/assets/images/perfiles/warning-amber.svg' />
                    <ImportanText>Importante:</ImportanText>
                  </WarninTitle>
                  <ul style={{ margin: '0px', padding: '0px 18px' }}>
                    <li>
                      <DescriptionText>
                        El plazo de rescate comienza a correr el día hábil siguiente si tu solicitud
                        fue realizada antes de las 4:00 PM y el día hábil subsiguiente si la
                        realizas luego de esa hora.
                      </DescriptionText>
                    </li>
                    <li>
                      <DescriptionText>
                        Este depósito es en Dólares, por lo que el monto solicitado será
                        transformado a pesos el día del depósito de acuerdo al tipo de cambio
                        correspondiente a la fecha.
                      </DescriptionText>
                    </li>
                    <li>
                      <DescriptionText>
                        El monto final a ser rescatado puede variar según el valor cuota de los
                        fondos que componen el portfolio al momento de procesar el rescate.
                      </DescriptionText>
                    </li>
                  </ul>
                </WarningMessage>
                <DividerCustom variant='inset' />
                <TermsAndConditions>
                  <ContentCheckBox gap={1}>
                    <Stack marginTop={{ xs: '8px', md: '0px' }}>
                      <CheckBoxOutlineBlank checked={isChecked} onChange={handleChangeCheckBox} />
                    </Stack>
                    <TextDeclaration>
                      Declaro entender los{' '}
                      <DeclarationSpan
                        variant='span'
                        component={'span'}
                        sx={{ cursor: 'pointer' }}
                        onClick={openTC}>
                        términos y condiciones del rescate
                      </DeclarationSpan>{' '}
                      que estoy a punto de solicitar
                    </TextDeclaration>
                  </ContentCheckBox>
                </TermsAndConditions>
                <Stack
                  justifyContent={'center'}
                  direction={{ md: 'row', xs: 'column' }}
                  width={{ md: '60%', xs: '90%' }}
                  gap={2}
                  sx={{ margin: '26px 0px 0px 0px' }}>
                  <ButtonsTertiary
                    fullWidth
                    onClick={() => navigate('/myprofilerisk')}
                    name={'No por ahora'}
                  />
                  <ButtonsPrimary
                    disabled={!isChecked || submitSuccess}
                    fullWidth
                    onClick={() => handleConfirmRescue()}
                    name={submitSuccess ? 'Solicitando' : ' Confirmar'}
                  />
                </Stack>
              </RsContent>
            </RescueSolutionSection>
            <Stack
              sx={{
                width: '100%',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: '4rem',
              }}>
              <ButtonsTertiary name='Volver Atrás' onClick={() => handleSubmitRescue()} />
            </Stack>
          </Stack>
        </RescueBodyContainer>
      ) : (
        <Stack margin={'20px'}>
          <ReceivedRescuePortfolio
            rescueAmount={amountRescue}
            dateDDMMYY={dateDDMMYY}
            days={days}
            date={date}
          />
        </Stack>
      )}
    </>
  );
};

export default CardsResultRescue;
